export default [
  {
    party: {
      name: 'FIRST TIME MORTGAGE',
      fax: null,
      modified: '2018-07-16 14:33:55.888087+00',
      role: 'Creditor',
      address: '4545 N NORTHERN AVE\nPHOENIX, AZ 85112',
      email: null,
      case_party_id: 114838,
      added_date: '05/14/2007',
      phone: null,
    },
    associated: [
      {
        fax: null,
        lead: null,
        name: 'TEST 4 ATTORNEY',
        email: 'www.tammierae@aol.com',
        address: 'ATTORNEYS R US\n123 MAIN ST.\nPHOENIX, AZ 85000',
        phone: '602-555-5555',
      },
    ],
  },
  {
    party: {
      phone: '480-451-3053',
      added_date: '02/19/2007',
      email: null,
      case_party_id: 114839,
      address: 'PO BOX 12970\nSCOTTSDALE, AZ 85267-2970',
      role: 'Trustee',
      modified: '2018-07-16 14:33:55.926156+00',
      fax: null,
      name: 'DIANE MANN',
    },
    associated: [
      {
        phone: '480-961-1906',
        address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
        fax: '480-705-4425',
        name: 'JAMES J. GENTILE',
        lead: null,
        email: null,
      },
      {
        address: 'ATTORNEYS R US\n123 MAIN ST. Suite 200\nPHOENIX, AZ 85000',
        phone: '602-555-5555',
        email: null,
        fax: null,
        lead: null,
        name: 'TEST 3 ATTORNEY',
      },
    ],
  },
  {
    party: {
      modified: '2018-07-16 14:33:55.939242+00',
      fax: null,
      name: 'Joseph Wayne Sample',
      address: 'PO BOX 123\nCHANDLER, AZ 85226',
      role: 'Debtor',
      added_date: '02/19/2007',
      email: null,
      case_party_id: 114840,
      phone: null,
    },
    associated: [
      {
        fax: '480-705-4425',
        email: null,
        lead: null,
        name: 'JAMES J. GENTILE',
        phone: '480-961-1906',
        address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
      },
      {
        address: 'Sue\'s Law Firm, PC\n333 N. 3rd St,\nPhoenix, AZ 85000',
        phone: '602-555-5555',
        fax: null,
        email: 'sue_christensen@azb.uscourts.gov',
        lead: null,
        name: 'Sue Test',
        uuid: 21,
      },
    ],
  },
  {
    party: {
      added_date: '02/19/2007',
      case_party_id: 114841,
      email: null,
      phone: null,
      modified: '2018-07-16 14:33:55.955052+00',
      fax: null,
      name: 'Sarah Lynn Sample',
      address: 'PO BOX 123\nCHICAGO, IL 60605-0123',
      role: 'Joint Debtor',
    },
    associated: [
      {
        email: null,
        fax: '480-705-4425',
        lead: null,
        name: 'JAMES J. GENTILE',
        address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
        phone: '480-961-1906',
      },
      {
        address: 'Sue\'s Law Firm, PC\n333 N. 3rd St,\nPhoenix, AZ 85000',
        phone: '602-555-5555',
        fax: null,
        lead: null,
        email: 'sue_christensen@azb.uscourts.gov',
        name: 'Sue Test',
        uuid: 21,
      },
    ],
  },
  {
    associated: [
      {
        address: 'JAMES J. GENTILE, PC\n5355 W. CHANDLER BLVD., #7\nCHANDLER, AZ 85226',
        phone: '480-961-1906',
        lead: null,
        fax: '480-705-4425',
        email: null,
        name: 'JAMES J. GENTILE',
      },
    ],
    party: {
      case_party_id: 114842,
      email: null,
      added_date: '02/19/2007',
      phone: null,
      fax: null,
      name: 'U.S. Trustee\'s Office',
      modified: '2018-07-16 14:33:55.972618+00',
      role: 'U.S. Trustee',
      address: '230 N. First Avenue, Suite 204\nPhoenix, AZ 85003',
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/case/parties/partiesArray.js